import {
  SimpleGrid,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Card } from "../../../components/Card";
import ManyColumnType from "../../../components/Charts/ManyColumnType";
import { FilterYear } from "../../../components/templates/Filters/Year";
import { InternalHeader } from "../../../components/templates/InternalHeader";
import { useQuery } from "../../../hooks/query";
import { api } from "../../../services/api";

interface BarProps {
  units: {
    time: string;
    value: number;
    type: string;
  }[];
  invoicing: {
    time: string;
    value: number;
    type: string;
  }[];
}
interface Selected {
  year: string;
}
export function RegistrationVersusChurnDashboard() {
  const [data, setData] = useState<BarProps>({} as BarProps);
  const navigate = useNavigate();
  const query = useQuery();
  const [selected, setSelected] = useState<Selected>({
    year: query.get("year") ?? "",
  });
  useEffect(() => {
    api
      .get(`/dashboards/churn/registration?year=${selected.year}`)
      .then((response) => {
        setData(response.data);
      });
  }, [selected.year]);
  return (
    <>
      <InternalHeader title="MRR X Churn" has_filter={true}>
        <FilterYear
          onChange={(year) => {
            if (year) {
              setSelected({
                ...selected,
                year: year.value,
              });
              navigate(`/dashboard/comparativo/mrr/churn?year=${year.value}`);
            } else {
              setSelected({
                ...selected,
                year: "",
              });
              navigate(`/dashboard/comparativo/mrr/churn?year=`);
            }
          }}
        />
      </InternalHeader>

      <SimpleGrid columns={{ base: 1 }} spacing={2}>
        <Card
          border="#2b88a1"
          mb="20px"
          body={
            <Tabs isFitted variant="enclosed">
              <TabList mb="1em">
                <Tab>MRR Conquistado</Tab>
                <Tab>Unidade</Tab>
              </TabList>
              <TabPanels>
                <TabPanel>
                  <ManyColumnType data={data.invoicing ?? []} />
                </TabPanel>
                <TabPanel>
                  <ManyColumnType data={data.units ?? []} />
                </TabPanel>
              </TabPanels>
            </Tabs>
          }
        />
      </SimpleGrid>
    </>
  );
}
